import { Badge } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Notification } from '@work4all/models/lib/Classes/Notification.entity';
import { TimeTrackingStopwatch } from '@work4all/models/lib/Classes/TimeTrackingStopwatch.entity';

import { NotificationDate } from './components/NotificationDate';
import { NotificationIcon } from './components/NotificationIcon';
import { NotificationLayout } from './components/NotificationLayout';
import { NotificationText } from './components/NotificationText';
import { NotificationTitle } from './components/NotificationTitle';

export interface NotificationListItemStopwatchProps {
  className?: string;
  style?: React.CSSProperties;
  notification: Notification;
  onClick: () => void;
  count?: number;
}

export function NotificationListItemStopwatch(
  props: NotificationListItemStopwatchProps
) {
  const { className, style, notification, onClick, count = 1 } = props;

  const { t } = useTranslation();

  const stopwatch = notification.object as TimeTrackingStopwatch | undefined;

  const title = stopwatch?.project?.name || t('NAVIGATION.TIMETRACKING');
  const line1 = t('NOTIFICATION.STOPWATCH_TEXT_LINE_1');
  const line2 = t('NOTIFICATION.STOPWATCH_TEXT_LINE_2');

  return (
    <NotificationLayout
      className={className}
      style={style}
      unread={!notification.isRead}
      onClick={onClick}
    >
      <NotificationIcon>
        <Badge
          badgeContent={count.toString()}
          color={notification.isRead ? 'secondary' : 'primary'}
          invisible={count <= 1}
        >
          <Icon />
        </Badge>
      </NotificationIcon>
      <NotificationTitle unread={!notification.isRead}>
        {title}
      </NotificationTitle>
      <NotificationText>
        <div>{line1}</div>
        <div>{line2}</div>
        {stopwatch?.customer?.name && <div>{stopwatch.customer.name}</div>}
        {stopwatch?.project?.name && <div>{stopwatch.project.name}</div>}
      </NotificationText>
      <NotificationDate date={notification.insertTime} />
    </NotificationLayout>
  );
}

function Icon() {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="15"
        cy="16"
        r="10"
        stroke="#232735"
        strokeWidth="2"
        fill="none"
      />
      <rect x="13" y="5" width="4" height="3" rx="1" fill="#232735" />
      <path
        d="M15 16 L20 12"
        stroke="#232735"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <circle cx="15" cy="16" r="1.5" fill="#232735" />
    </svg>
  );
}
